// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/LogoutButton.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/LogoutButton.tsx");
  import.meta.hot.lastModified = "1747870550326.5513";
}
// REMIX HMR END

import { Link } from '@remix-run/react';
import { forwardRef } from 'react';
import { Button } from './Button';
export const LogoutButton = forwardRef(_c = ({
  label = 'Sign Out',
  displayType = 'danger',
  className = 'text-sm',
  ...rest
}, ref) => {
  return <Link to="/logout" prefetch="intent">
				<Button ref={ref} type="button" displayType={displayType} className={className} {...rest}>
					{label}
				</Button>
			</Link>;
});
_c2 = LogoutButton;
LogoutButton.displayName = 'LogoutButton';
var _c, _c2;
$RefreshReg$(_c, "LogoutButton$forwardRef");
$RefreshReg$(_c2, "LogoutButton");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;